export const actionTypes = {
    UPDATE_UNIT_SELECTION: 'userProfile/UPDATE_UNIT_SELECTION',
};

export const unitStandards = {
    Metric: 1,
    Imperial: 2
};
